import { Component } from "@angular/core";
import { Events, ViewController } from "ionic-angular";
import { ReferralsServiceProvider } from "../../../providers/patient-charts/referrals-service";

@Component({
  templateUrl: "eligibility-modal.html",
  selector: "eligibility-modal",
})
export class EligibilityPageModal {
  public name = "...";

  constructor(
    private viewCtrl: ViewController,
    private events: Events,
    private referralService: ReferralsServiceProvider
  ) {
    const referallSub = this.referralService
      .getPatientById(this.viewCtrl.data.patientId, false)
      .subscribe();

    this.events.subscribe("reloadBriefBarEvent", (data: any) => {
      if (data) {
        this.name = data.fullName;
      }
      referallSub.unsubscribe();
      this.events.unsubscribe("reloadBriefBarEvent", null);
    });
  }
  dismiss() {
    this.viewCtrl.dismiss();
    this.navigateToComplete();
  }

  navigateToComplete() {
    window.location.href =
      window.location.href.split("#")[0] +
      "#/referral-tabs/referral/patient-details/eligibility-complete/" +
      this.referralService.PATIENT_ID;
  }
}



// WEBPACK FOOTER //
// ./src/pages/patient-chart/eligibility/eligibility-modal.ts